import React from 'react';
import Text from 'components/base/Text';
import Tooltip from '@material-ui/core/Tooltip';
import { Flex } from 'components/base/layout-components';
import { ISSUE_STATES, ISSUE_STATES_DISPLAY_VALUES } from '../pulse.common';

const FiltersInfo = ({
  issueStateFilterValues,
  issueTypeFilterValues,
  topBarIssueTypes
}) => {
  const hasStateFilters =
    !!issueStateFilterValues.length &&
    issueStateFilterValues.length !== Object.values(ISSUE_STATES).length;
  const hasTypeFilters =
    !!issueTypeFilterValues.length &&
    issueTypeFilterValues.length !== topBarIssueTypes.length;

  if (!hasStateFilters && !hasTypeFilters) {
    return null;
  }

  return (
    <>
      <Text pl='0.5rem' size='large' color='botticelli'>
        {' '}
        |{' '}
      </Text>
      <Tooltip
        title={
          <Flex direction='column'>
            <Text pt='0.5rem' pb='0.5rem' size='medium'>
              Filtered by:
            </Text>
            {hasStateFilters && (
              <Text pb='0.5rem'>{`Status: ${issueStateFilterValues
                .map(value => ISSUE_STATES_DISPLAY_VALUES[value].text)
                .join(', ')}`}</Text>
            )}
            {hasTypeFilters && (
              <Text pb='0.5rem'>{`Type: ${issueTypeFilterValues.join(
                ', '
              )}`}</Text>
            )}
          </Flex>
        }
      >
        <Text pl='0.5rem' color='shuttleGray'>
          {(hasStateFilters ? issueStateFilterValues.length : 0) +
            (hasTypeFilters ? issueTypeFilterValues.length : 0)}{' '}
          Filters
        </Text>
      </Tooltip>
    </>
  );
};

export default FiltersInfo;
